import { usePrivy } from '@privy-io/react-auth';

import { provider } from '../config/provider.config';

function useWrappedRPC() {
  const { sendTransaction } = usePrivy();

  const sendTransactionWithGas = async (transactionRequest, txUiConfig) => {
    try {
      const { maxFeePerGas, maxPriorityFeePerGas } = await provider.getCustomizedFeeData();

      const tx = {
        ...transactionRequest,
        maxFeePerGas,
        maxPriorityFeePerGas,
      };
      const result = await sendTransaction(tx, txUiConfig);

      return result;
    } catch (error) {
      throw error;
    }
  };

  return { sendTransactionWithGas, provider };
}

export default useWrappedRPC;
